import type { Application, Controller } from "@hotwired/stimulus";

const PANELS = ["map-tray", "map-calibration", "map-dice", "map-sheet", "map-combat", "map-sound"];

// The board shows one panel at a time: opening one closes the others.
export function closeOtherPanels(application: Application, element: Element, self: string) {
	for (const identifier of PANELS) {
		if (identifier !== self) (application.getControllerForElementAndIdentifier(element, identifier) as (Controller & { close(): void }) | null)?.close();
	}
}
